import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[smartTooltip]',
  standalone: true,
})
export class SmartTooltipDirective implements AfterViewInit, OnDestroy {

  @Input('smartTooltip') content!: any;
  @Input() lines = 1;

  private isOverflowing = false;
  private resizeObserver!: ResizeObserver;
  private frameId: number | null = null;
  private currentLineClass: string | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  @HostBinding('class.truncate')
  get truncateClass() {
    return this.isPrimitiveContent();
  }

  @HostBinding('attr.data-tooltip-enabled')
  tooltipEnabledAttr: '' | null = null;

  ngAfterViewInit() {
    if (!this.isPrimitiveContent()) return;
    this.updateLineClampClass();
    const el = this.el.nativeElement;
    this.resizeObserver = new ResizeObserver(() => {
      if (this.frameId) cancelAnimationFrame(this.frameId);

      this.frameId = requestAnimationFrame(() => {
        this.checkOverflow();
      });
    });
    this.resizeObserver.observe(el);
    queueMicrotask(() => this.checkOverflow());
  }

  private isPrimitiveContent(): boolean {
    return typeof this.content === 'string';
  }

  private checkOverflow() {
    const el = this.el.nativeElement;

    this.isOverflowing =
      el.scrollHeight > el.clientHeight ||
      el.scrollWidth > el.clientWidth;

    this.tooltipEnabledAttr = this.isOverflowing ? '' : null;
  }

  private updateLineClampClass() {
    if (!this.isPrimitiveContent()) return;

    const el = this.el.nativeElement;
    if (this.currentLineClass) this.renderer.removeClass(el, this.currentLineClass);

    const newClass = `truncate-${this.lines}`;
    this.renderer.addClass(el, newClass);
    this.currentLineClass = newClass;
  }
  
  isEnabled(): boolean {
    return this.isPrimitiveContent()? this.isOverflowing : true;
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }
}
